(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var tpl = document.body?.dataset?.template || '';
    if (tpl !== 'product') return;

    var data = window.sachetProductSticky || null;
    if (!data || data.available === false) return;

    function isMobile() {
      return window.innerWidth < 750;
    }

    function formatMoney(cents) {
      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, data.money_format || '${{amount}}');
        }
      } catch (e) {}
      var rupees = Math.round((cents || 0) / 100);
      return 'Rs ' + rupees.toLocaleString('en-PK');
    }

    function getSelectedVariantId() {
      var idInput =
        document.querySelector('product-form input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');

      if (idInput && idInput.value) return String(idInput.value);
      return String(data.selected_variant_id || '');
    }

    function getVariantById(variantId) {
      if (!data.variants || !data.variants.length) return null;
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(variantId)) return data.variants[i];
      }
      return null;
    }

    function getMainAddButton() {
      var b1 = document.querySelector('product-form form[action*="/cart/add"] button[type="submit"], product-form button[name="add"]');
      if (b1 && !b1.closest('.sachet-routine-bundle')) return b1;

      var main =
        document.querySelector('section[id^="MainProduct-"]') ||
        document.querySelector('.main-product') ||
        document.querySelector('.product');

      if (main) {
        var list = main.querySelectorAll('form[action*="/cart/add"] button[type="submit"], button[name="add"]');
        for (var i = 0; i < list.length; i++) {
          if (!list[i].closest('.sachet-routine-bundle')) return list[i];
        }
      }

      return null;
    }

    function isCartDrawerOpen() {
      var drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('.cart-drawer') ||
        document.querySelector('drawer-cart');

      if (!drawer) return false;

      return (
        drawer.hasAttribute('open') ||
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('active') ||
        drawer.classList.contains('drawer--is-open') ||
        drawer.classList.contains('cart-drawer--active')
      );
    }

    var stickyBar = document.createElement('div');
    stickyBar.className = 'sachet-sticky-atc';
    stickyBar.innerHTML =
      '<div class="sachet-sticky-atc__inner">' +
        '<div class="sachet-sticky-atc__info">' +
          '<div class="sachet-sticky-atc__title-row">' +
            '<div class="sachet-sticky-atc__title">' + (data.title || 'Product') + '</div>' +
            '<div class="sachet-sticky-atc__variant-pill" data-sticky-variant></div>' +
          '</div>' +
        '</div>' +
        '<div class="sachet-sticky-atc__actions">' +
          '<div class="sachet-sticky-atc__price-line" data-sticky-price></div>' +
          '<button type="button" class="sachet-sticky-atc__btn">' +
            '<span class="sachet-sticky-atc__btn-label-main">Add to cart</span>' +
          '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(stickyBar);

    var stickyBtn = stickyBar.querySelector('.sachet-sticky-atc__btn');
    var priceLine = stickyBar.querySelector('[data-sticky-price]');
    var variantPill = stickyBar.querySelector('[data-sticky-variant]');
    var mainButtonVisible = true;
    var lastId = getSelectedVariantId();

    function setVisible(show) {
      stickyBar.style.display = show ? 'block' : 'none';
    }

    function renderFromVariant() {
      var vid = getSelectedVariantId();
      var v = getVariantById(vid);
      if (!v) return;

      var onSale = v.compare_at_price && v.compare_at_price > v.price;

      if (priceLine) {
        if (onSale) {
          priceLine.innerHTML =
            '<span class="sachet-sticky-atc__price--sale">' + formatMoney(v.price) + '</span>' +
            '<span class="sachet-sticky-atc__price--compare">' + formatMoney(v.compare_at_price) + '</span>';
        } else {
          priceLine.innerHTML =
            '<span class="sachet-sticky-atc__price--single">' + formatMoney(v.price) + '</span>';
        }
      }

      var btnLabel = stickyBar.querySelector('.sachet-sticky-atc__btn-label-main');
      if (btnLabel) btnLabel.textContent = onSale ? 'Get Sale Price' : 'Add to cart';

      if (variantPill) {
        var t = (v.public_title || v.title || '').trim();
        if (!t || t.toLowerCase() === 'default title') {
          variantPill.style.display = 'none';
          variantPill.textContent = '';
        } else {
          variantPill.style.display = 'inline-flex';
          variantPill.textContent = t;
        }
      }
    }

    function updateVisibilityLight() {
      if (isCartDrawerOpen()) return setVisible(false);
      if (!isMobile()) return setVisible(false);

      var scrolled = window.scrollY || window.pageYOffset;
      setVisible(!mainButtonVisible && scrolled > 80);
    }

    function syncVariant() {
      var now = getSelectedVariantId();
      if (now && now !== lastId) {
        lastId = now;
        renderFromVariant();
      }
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var mainBtn = getMainAddButton();
        if (mainBtn && !mainBtn.disabled) mainBtn.click();
      });
    }

    var mainBtn = getMainAddButton();

    if ('IntersectionObserver' in window && mainBtn) {
      var observer = new IntersectionObserver(function (entries) {
        mainButtonVisible = entries[0] && entries[0].isIntersecting;
        updateVisibilityLight();
      }, {
        root: null,
        threshold: 0.01
      });

      observer.observe(mainBtn);
    } else {
      mainButtonVisible = false;
    }

    document.addEventListener('change', function (e) {
      var t = e && e.target;
      if (!t) return;
      if (t.matches('variant-radios input, variant-selects select, select[name="id"], input[name="id"]')) {
        setTimeout(function () {
          syncVariant();
          updateVisibilityLight();
        }, 50);
      }
    });

    window.addEventListener('scroll', updateVisibilityLight, { passive: true });
    window.addEventListener('resize', function () {
      setTimeout(updateVisibilityLight, 150);
    });

    window.addEventListener('pageshow', function () {
      setTimeout(function () {
        syncVariant();
        updateVisibilityLight();
      }, 150);
    });

    renderFromVariant();
    updateVisibilityLight();
  });
})();
